import React from "react";
import { Modal } from "reactstrap";
import classNames from "classnames";
import { useSelector } from "react-redux";

import { useAppDispatch } from "../../redux";
import { saveCampaignEmailChannelAction } from "../../redux/dashboard/campaigns-slice";

import SectionHeader from "../section-header";
import Button from "../button";

import Icon from "../../assets/svg";

import { getUserDataAction } from "../../redux/auth/user-slice";

type Props = {
  isOpen: boolean;
  close: any;
  selectedCampaign: any;
  chosenSender: string;
  setCampaignSender: React.Dispatch<React.SetStateAction<string>>;
  setIsKlaviyoAuthModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setIsKlaviyoTemplateModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const ChangeCampaignSenderConfirmationModal = ({
  isOpen,
  close,
  selectedCampaign,
  chosenSender,
  setCampaignSender,
  setIsKlaviyoAuthModalOpen,
  setIsKlaviyoTemplateModalOpen,
}: Props) => {
  const dispatch = useAppDispatch();
  const { isSavingCampaignEmailChannel } = useSelector(
    (state: any) => state.campaignsSlice
  );
  const { isFetchingUserData } = useSelector((state: any) => state.userSlice);

  const handleSenderConfirmation = async () => {
    await changeEmailChannel();

    if (!selectedCampaign?.klaviyo_campaign_id && chosenSender === "Klaviyo") {
      localStorage.setItem("konvas_campaign_id", selectedCampaign?.id);

      const response = await dispatch(getUserDataAction());

      console.log("user response:", response);

      const isKlaviyoAuthenticated =
        response?.user?.is_klaviyo_authenticated === "1";

      isKlaviyoAuthenticated
        ? setIsKlaviyoTemplateModalOpen(true)
        : setIsKlaviyoAuthModalOpen(true);
    }
    close();
  };

  const changeEmailChannel = async () => {
    const emailChannel = {
      id: selectedCampaign?.id,
      email_channel: chosenSender,
    };
    await dispatch(saveCampaignEmailChannelAction(emailChannel));
    setCampaignSender(chosenSender);
  };

  return (
    <Modal className="campaign_sender_confirmation_modal" isOpen={isOpen}>
      <div className="modal_header">
        <SectionHeader
          leftSide={<div className="title_box">Confirm Campaign Sender</div>}
          rightSide={
            <>
              <div className="icon" onClick={close}>
                <Icon name="close" />
              </div>
            </>
          }
        />
      </div>

      <div className="modal_body">
        <div className="content_box">
          <p>
            Are you sure you want to change your email sender from{" "}
            <strong
              className={classNames({
                konvas: chosenSender === "Klaviyo",
                klaviyo: chosenSender === "Konvas",
              })}
            >
              {chosenSender === "Konvas AI" ? "Klaviyo" : "Konvas AI"}
            </strong>{" "}
            to{" "}
            <strong
              className={classNames({
                konvas: chosenSender === "Konvas AI",
                klaviyo: chosenSender === "Klaviyo",
              })}
            >
              {chosenSender === "Konvas AI" ? "Konvas AI" : "Klaviyo"}
            </strong>
            ?
          </p>
          <div className="btn_box">
            <Button
              text="Cancel"
              onClick={close}
              className="btn_secondary"
              disabled={isSavingCampaignEmailChannel || isFetchingUserData}
            />
            <Button
              text="Confirm"
              onClick={handleSenderConfirmation}
              disabled={isSavingCampaignEmailChannel || isFetchingUserData}
              loading={isSavingCampaignEmailChannel || isFetchingUserData}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ChangeCampaignSenderConfirmationModal;
